import $ from 'jquery';


export const slideClosed = {
  animation: { marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 0, height: 0, opacity: [0, 'easeOutExpo'] },
  duration: 150
};
export const slideOpen = {
  animation: 'reverse',
  duration: 150,
  complete(elements) { $(elements).removeAttr('style'); }
};

export const leaveSide = {
  animation: { width: 0, opacity: [0, 'easeOutExpo'] },
  duration: 150
};
export const enterSide = {
  animation: 'reverse',
  duration: 150
};
